
export class CoreModel {
/**
 * Add/remove component html to/from the browser DOM. Default must be specified in the templates.
 */
display?: boolean;
/**
 * Disbale or enable the component. Default must be specified in the templates.
 */
disable?: boolean;
/**
 * Component template name/path.
 */
compTemplate?: string;
/**
 * Tooltip on hover of the component with structure:</p>
 * <pre>
 * {{'{'}}
 *  message: string, // Tip to be displayed
 *  position: string // Tooltip positon: 'top', 'right' ,'left', 'bottom'
 * {{'}'}}
 * </pre>
 */
tooltip?: any;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

function CoreModel_tsickle_Closure_declarations() {
/**
 * Add/remove component html to/from the browser DOM. Default must be specified in the templates.
 * @type {?}
 */
CoreModel.prototype.display;
/**
 * Disbale or enable the component. Default must be specified in the templates.
 * @type {?}
 */
CoreModel.prototype.disable;
/**
 * Component template name/path.
 * @type {?}
 */
CoreModel.prototype.compTemplate;
/**
 * Tooltip on hover of the component with structure:</p>
 * <pre>
 * {{'{'}}
 *  message: string, // Tip to be displayed
 *  position: string // Tooltip positon: 'top', 'right' ,'left', 'bottom'
 * {{'}'}}
 * </pre>
 * @type {?}
 */
CoreModel.prototype.tooltip;
}

